
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"layer","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 167.13 167.42","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M107.6 68.62c1.5 4.4 5.6 7.1 10.4 7.1 1.2 0 2.4-.3 3.6-.6 5.6-2.1 8.6-8.3 6.5-13.9-3.6-9.8-11-17.5-21.3-22.2-5.3-2.4-11.9 0-14.5 5.3-2.4 5.3 0 11.9 5.3 14.5 5.3 2.1 8.9 5.7 10 9.8zM104.1.22c-5.9-1.2-11.6 2.7-12.7 8.6-1.2 5.9 2.7 11.6 8.6 12.7 24.6 5 41.5 21.3 45.6 45.3.9 5.3 5.6 8.9 10.7 8.9.6 0 1.2 0 1.8-.3 5.9-1.2 9.8-6.8 8.9-12.4-6-32.6-29.4-56.3-62.9-62.8z","fill":"#ff9e1a"}}),_c('path',{staticClass:"st1",attrs:{"d":"M76.5 108.62c-9.8 0-18.1-8-18.1-18.1 0-9.8 8-18.1 18.1-18.1 5.9 0 11-4.7 11-11 0-5.9-4.7-11-11-11-21.9 0-39.7 17.8-39.7 39.7 0 21.9 17.8 39.7 39.7 39.7s39.7-17.8 39.7-39.7c0-5.9-4.7-11-11-11-5.9 0-11 4.7-11 11 .4 10.5-7.6 18.5-17.7 18.5z","fill":"#1856ed"}}),_c('path',{staticClass:"st1",attrs:{"d":"M142.3 79.92c-5.9 0-11 4.7-11 11 0 30.2-24.6 54.8-54.8 54.8s-54.8-24.6-54.8-54.8c0-30.2 24.6-54.8 54.8-54.8 5.9 0 11-4.7 11-11 0-5.9-4.7-11-11-11-42.1 0-76.5 34.4-76.5 76.8 0 42.1 34.4 76.5 76.5 76.5s76.5-34.4 76.5-76.5c0-6.3-4.8-11-10.7-11z","fill":"#1856ed"}})])
          )
        }
      }
    